<template>
  <span>
    <Icon :id="id"
          :title="title"
          name="info">
    </Icon>
    <BTooltip v-model:show="show"
              :placement="tooltipPlacement"
              :target="id">
      <slot>
        <span v-if="titleIsHtml"
              v-html="title"></span>
        <span v-else>
          {{ title }}
        </span>
      </slot>
    </BTooltip>
  </span>
</template>

<script>
  import { v4 as uuid } from 'uuid';
  import { BTooltip } from 'bootstrap-vue';
  import { translator } from '~/zf/frontend/common/mixins';
  import Placement from '~/zf/frontend/common/bootstrapVue/Placement';
  import Icon from './Icon.vue';

  export default {
    name: 'InfoIconWithTooltip',
    compatConfig: {
      MODE: 3,
      COMPONENT_FUNCTIONAL: true,
    },
    components: {
      Icon,
      BTooltip,
    },
    mixins: [
      translator,
    ],
    props: {
      title: {
        default: '',
        type: String,
      },
      titleIsHtml: {
        type: Boolean,
        default: false,
      },
      tooltipPlacement: {
        default: Placement.TOP,
      },
    },
    data() {
      return {
        show: undefined,
        Placement,
        id: `id-${uuid()}`,
      };
    },
    methods: {
      changeVisibility(visibility) {
        this.show = visibility;
      },
    },
  };
</script>
